export const GET_TELEPHONE_COMPANIES = "getTelephoneCompanies";
export const GET_TELEPHONE_COMPANIES_PENDING = "getTelephoneCompanies/pending";
export const GET_TELEPHONE_COMPANIES_REJECTED =
  "getTelephoneCompanies/rejected";
export const GET_TELEPHONE_COMPANIES_FULFILLED =
  "getTelephoneCompanies/fulfilled";
